import { motion } from "framer-motion";
import {
  Cctv,
  ShieldAlert,
  KeyRound,
  Phone,
  Flame,
  DoorOpen,
  ListTodo,
  MonitorCog,
} from "lucide-react";
import { useApp } from "@/context/AppProviders";

const icons = [
  Cctv,
  ShieldAlert,
  KeyRound,
  Phone,
  Flame,
  DoorOpen,
  ListTodo,
  MonitorCog,
];

const Disciplines = () => {
  const { t } = useApp();
  const d = t.disciplines;

  return (
    <section
      id="disciplines"
      data-testid="disciplines-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
            {d.label}
          </p>
          <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
            {d.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {d.subtitle}
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
          {d.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={item.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: (i % 4) * 0.06 }}
                data-testid={`discipline-${i}`}
                className="group relative rounded-sm border border-border bg-card p-5 transition-colors duration-200 hover:border-blue-600/50"
              >
                {item.isNew && (
                  <span className="absolute right-3 top-3 rounded-sm bg-emerald-500/15 px-1.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wide text-emerald-400">
                    {d.newBadge}
                  </span>
                )}
                <div className="flex h-10 w-10 items-center justify-center rounded-sm border border-blue-600/30 bg-blue-600/10 text-blue-500 transition-colors duration-200 group-hover:bg-blue-600 group-hover:text-white">
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </div>
                <h3 className="font-heading mt-4 text-base font-medium tracking-tight">
                  {item.name}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Disciplines;
